import axiosInstance from "api/axiosInstance";

import type { TourApprovalListResponse, TourApprovalListParams, TourApprovalActionRequest, TourApprovalDetail } from "api/types/tour-approval.types";

const BASE = "/server/buccl_main/api/v1/travel-products-approvals/";

export const tourApprovalsService = {
  list: (params?: TourApprovalListParams) => axiosInstance.get<TourApprovalListResponse>(BASE, { params }),

  // 승인 대기/완료 투어 상세 조회 (어드민 전용 엔드포인트)
  get: (id: number) => axiosInstance.get<TourApprovalDetail>(`${BASE}${id}/`),

  action: (id: number, payload: TourApprovalActionRequest) => axiosInstance.post(`${BASE}${id}/action/`, payload),
};
